<!-- eslint-disable no-irregular-whitespace -->
<template>
  <page>
    <div class="text-main-content">
      <div class="wrapper">

        <center>
          <div class="text-main-content-title">
            特定商取引法に基づく表示<span class="mini">（スズキ定額マイカー）</span>
          </div>
        </center>

        <!-- text-main-content-box -->
        <div class="text-main-content-box">

          <table class="text-main-content-box-info-tb mb-20">
            <tr>
              <th>役務提供事業者</th>
              <td>
                スズキファイナンス株式会社
              </td>
            </tr>
            <tr>
              <th>所在地</th>
              <td>
                〒４３２－８６１１<br>
                静岡県浜松市中央区高塚町３００番地
              </td>
            </tr>
            <tr>
              <th>電話番号</th>
              <td>
                ０５３－４４５－０７００
              </td>
            </tr>
            <tr>
              <th>業務責任者</th>
              <td>
                秋田　秀和
              </td>
            </tr>
            <tr>
              <th>商品・役務の対価</th>
              <td>
                自動車リース契約のリース料は対象自動車により異なります。<br>
                車種毎のリース料金プランは下記ページをご覧ください。<br>
                https://www.suzuki.co.jp/car/teigakumycar/
              </td>
            </tr>
            <tr>
              <th>商品・役務の対価の<br class="pc tab">支払い時期、方法</th>
              <td>
                <span class="text-base"><span class="text-in">・</span>リース開始日（納車日）の属する月の翌月を第１回目支払月とし、原則リース期間が満了する月が最終回支払月となります。
                当該支払期間における毎月のお支払い日は１０日（クレジットカード会社への請求日）となります。</span>
                <span class="text-base"><span class="text-in">＊</span>お客様のカード会社へのお支払い日（引落し日）はご契約されているカード会社により異なります。</span>
                <span class="text-base"><span class="text-in">・</span>クレジットカード決済</span>
              </td>
            </tr>
            <tr>
              <th>商品・役務の提供時期</th>
              <td>
                リース車両の納車時期につきましては、変更登録に必要な書類等が取扱販売会社に到達後、遅滞なく変更登録を実施したうえで取扱販売会社からご連絡いたします。<br>
                お客様と取扱販売会社との間で日程を調整され、取扱販売会社の店舗で納車を行います。<br>
                ただし、お客様の都合により納車ができない場合はこの限りではありません。
              </td>
            </tr>
            <tr>
              <th>申込みの有効期限及び<br class="pc tab">キャンセル等</th>
              <td>
                <span class="text-base"><span class="text-in">・</span>リース契約の成立前であれば、申込みのキャンセルは可能です。<br>
                この場合キャンセル料は不要です。</span><br>
                <span class="text-base"><span class="text-in">＊</span>リース契約の成立日とは、お客様が当社からの承諾通知を受け本契約の成立を希望する旨通知した日となります。</span><br>
                <span class="text-base"><span class="text-in">・</span>契約成立後は、キャンセル（車種変更等）はできません。</span>
              </td>
            </tr>
            <tr>
              <th>商品・役務の対価以外にお客様が負担すべき金銭及び内容</th>
              <td>
                <span class="text-base"><span class="text-in">・</span>お客様には、リース料以外に次の費用等をご負担いただきます。</span><br>
                <span class="text-base-2"><span class="text-in">１．</span>リース車両の使用・保管及び保守・点検・修繕・整備等に係る一切の費用及び公租公課（リース契約に含まれる費用及び公租公課を除く）。</span><br>
                <span class="text-base-2"><span class="text-in">２．</span>リース契約に付帯される自動車保険によって補填されない費用。<br>
                （１事故あたり５万円の免責額及び保証限度額以上の金額）</span><br>
                <span class="text-base-2"><span class="text-in">３．</span>リース車両の滅失・毀損、お客様の契約違反その他リース契約に定める事由により、リース期間満了前にリース契約が解除され、終了する場合における当社所定の中途解約金。</span><br>
                <span class="text-base-2"><span class="text-in">４．</span>リース契約成立後は原則として中途解約はできません。<br>
                ただし、当社が中途解約を認めた場合、所定の中途解約金をお支払いいただきます。</span><br>
                <span class="text-base-2"><span class="text-in">５．</span>リース契約が完了又は解除により終了した場合におけるリース車両の返還又は引取りに要する一切の費用及び原状回復に要する費用並びに契約走行距離を超過した場合１Ｋｍあたり１０円（税込み）の清算金。</span><br>
                <span class="text-base-2"><span class="text-in">６．</span>当社が必要に応じて請求した場合における公正証書の作成費用及び当社がリース契約に定める権利を保全するために必要な措置に係る費用。</span>
              </td>
            </tr>
            <tr>
              <th>商品に品質等の不具合が<br class="pc tab">あった場合</th>
              <td>
                リース車両の引渡し後、リース車両の規格・仕様・品質・性能がリース契約の内容に適合されないことが発見されたときは、お客様は取扱販売会社又はスズキ株式会社に対して修理、整備等の履行を請求するものとし、その範囲、条件についてはリース車両の保証書の定めに従うものとします。
              </td>
            </tr>
          </table>

          <p class="t-right">以上</p>

        </div>
        <!-- /text-main-content-box -->

      </div>
    </div>
  </page>
</template>
<!-- eslint-enable no-irregular-whitespace -->

<script lang="ts">
import { defineComponent } from 'vue';
import Page from '@/components/Page.vue';

export default defineComponent({
  components: {
    Page,
  },
  setup () {
    return {};
  },
});

</script>

<style lang="scss" scoped>
  .header-logo {
    margin-top: 80px;
  }
</style>